// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../css-loader/dist/cjs.js!./plugin-sidebar.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../../../css-loader/dist/cjs.js!./webview.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../../../css-loader/dist/cjs.js!./tree.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 Red Hat, Inc. and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.spinnerContainer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexcontainer {
  display: flex;
}

.row {
  width: 100%;
}

.column {
  flex-direction: column;
}

.theia-plugin-view-container {
  /*
        It might take a second or two until the real plugin mask is loaded
        To prevent flickering on the icon, we set a transparent mask instead
        Since masks only support images, svg or gradients, we create a transparent gradient here
    */
  -webkit-mask: linear-gradient(transparent, transparent);
  mask: linear-gradient(transparent, transparent);
  background-color: var(--theia-activityBar-inactiveForeground);
}

.theia-plugin-file-icon,
.theia-plugin-file-icon::before,
.theia-plugin-folder-icon,
.theia-plugin-folder-icon::before,
.theia-plugin-folder-expanded-icon,
.theia-plugin-folder-expanded-icon::before,
.theia-plugin-root-folder-icon,
.theia-plugin-root-folder-icon::before,
.theia-plugin-root-folder-expanded-icon,
.theia-plugin-root-folder-expanded-icon::before {
  padding-right: var(--theia-ui-padding);
  width: var(--theia-icon-size);
  height: var(--theia-content-line-height);
  line-height: inherit !important;
  display: inline-block;
}

.p-TabBar.theia-app-sides .theia-plugin-file-icon,
.p-TabBar.theia-app-sides .theia-plugin-file-icon::before,
.p-TabBar.theia-app-sides .theia-plugin-folder-icon,
.p-TabBar.theia-app-sides .theia-plugin-folder-icon::before,
.p-TabBar.theia-app-sides .theia-plugin-folder-expanded-icon,
.p-TabBar.theia-app-sides .theia-plugin-folder-expanded-icon::before,
.p-TabBar.theia-app-sides .theia-plugin-root-folder-icon,
.p-TabBar.theia-app-sides .theia-plugin-root-folder-icon::before,
.p-TabBar.theia-app-sides .theia-plugin-root-folder-expanded-icon,
.p-TabBar.theia-app-sides .theia-plugin-root-folder-expanded-icon::before {
  padding: 0px !important;
  width: var(--theia-private-sidebar-icon-size) !important;
  height: var(--theia-private-sidebar-icon-size) !important;
  background-size: var(--theia-private-sidebar-icon-size) !important;
  font-size: var(--theia-private-sidebar-icon-size) !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/plugin-ext/src/main/browser/style/index.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;;;;KAIG;EACH,uDAAuD;EACvD,+CAA+C;EAC/C,6DAA6D;AAC/D;;AAEA;;;;;;;;;;EAUE,sCAAsC;EACtC,6BAA6B;EAC7B,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;;;;;;;EAUE,uBAAuB;EACvB,wDAAwD;EACxD,yDAAyD;EACzD,kEAAkE;EAClE,4DAA4D;AAC9D","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 Red Hat, Inc. and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n.spinnerContainer {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flexcontainer {\n  display: flex;\n}\n\n.row {\n  width: 100%;\n}\n\n.column {\n  flex-direction: column;\n}\n\n.theia-plugin-view-container {\n  /*\n        It might take a second or two until the real plugin mask is loaded\n        To prevent flickering on the icon, we set a transparent mask instead\n        Since masks only support images, svg or gradients, we create a transparent gradient here\n    */\n  -webkit-mask: linear-gradient(transparent, transparent);\n  mask: linear-gradient(transparent, transparent);\n  background-color: var(--theia-activityBar-inactiveForeground);\n}\n\n.theia-plugin-file-icon,\n.theia-plugin-file-icon::before,\n.theia-plugin-folder-icon,\n.theia-plugin-folder-icon::before,\n.theia-plugin-folder-expanded-icon,\n.theia-plugin-folder-expanded-icon::before,\n.theia-plugin-root-folder-icon,\n.theia-plugin-root-folder-icon::before,\n.theia-plugin-root-folder-expanded-icon,\n.theia-plugin-root-folder-expanded-icon::before {\n  padding-right: var(--theia-ui-padding);\n  width: var(--theia-icon-size);\n  height: var(--theia-content-line-height);\n  line-height: inherit !important;\n  display: inline-block;\n}\n\n.p-TabBar.theia-app-sides .theia-plugin-file-icon,\n.p-TabBar.theia-app-sides .theia-plugin-file-icon::before,\n.p-TabBar.theia-app-sides .theia-plugin-folder-icon,\n.p-TabBar.theia-app-sides .theia-plugin-folder-icon::before,\n.p-TabBar.theia-app-sides .theia-plugin-folder-expanded-icon,\n.p-TabBar.theia-app-sides .theia-plugin-folder-expanded-icon::before,\n.p-TabBar.theia-app-sides .theia-plugin-root-folder-icon,\n.p-TabBar.theia-app-sides .theia-plugin-root-folder-icon::before,\n.p-TabBar.theia-app-sides .theia-plugin-root-folder-expanded-icon,\n.p-TabBar.theia-app-sides .theia-plugin-root-folder-expanded-icon::before {\n  padding: 0px !important;\n  width: var(--theia-private-sidebar-icon-size) !important;\n  height: var(--theia-private-sidebar-icon-size) !important;\n  background-size: var(--theia-private-sidebar-icon-size) !important;\n  font-size: var(--theia-private-sidebar-icon-size) !important;\n}\n\n@import \"./plugin-sidebar.css\";\n@import \"./webview.css\";\n@import \"./tree.css\";\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
